



























import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import MarkdownEditor from 'components/MarkdownEditor.vue'
import api from 'src/assets/api/gql'
import ForumTopicPostEdit from 'src/graphql/forum/ForumTopicPostEdit.gql'
import { ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    MarkdownEditor
  }
})
export default class ForumPostButtonEdit extends Vue {
  text = ''

  @Prop()
  readonly topic!: ForumTopic

  @Prop()
  readonly post!: ForumTopicPost

  @Ref()
  readonly dialog!: DialogFullscreen

  get isTextEmpty () {
    return this.text.trim() === ''
  }

  async edit () {
    this.text = this.post.text || ''
    this.dialog.show()
  }

  async create () {
    if (!this.isTextEmpty) {
      await api.mutate({
        query: ForumTopicPostEdit,
        variables: {
          forumTopicId: this.topic.id,
          postId: this.post.id,
          text: this.text.trim()
        }
      })
      this.$emit('update', { text: this.text.trim() })
      this.dialog.hide()
    }
  }
}
